const AuthLive = {
    isAuthenticated: false,
    authenticate() {
        if (sessionStorage.getItem("liveToken")) {
            this.isAuthenticated = true;
        }
    },
    signout() {
        this.isAuthenticated = false;
        sessionStorage.removeItem("liveToken");
    },
    getAuth() {
        return this.isAuthenticated;
    },
    checkAuth() {        
        this.authenticate();
        return this.isAuthenticated;
    },
};

export default AuthLive;